import script from "./EditConfigurations.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditConfigurations.vue?vue&type=script&setup=true&lang=ts"

import "./EditConfigurations.vue?vue&type=style&index=0&id=078c339e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-078c339e"]])

export default __exports__